var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 39,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Abhar Final design"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-11756 -2614C-11756 -2615.1 -11755.1 -2616 -11754 -2616H6761C6762.1 -2616 6763 -2615.1 6763 -2614V5979C6763 5980.1 6762.11 5981 6761 5981H-11754C-11755.1 5981 -11756 5980.1 -11756 5979V-2614Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Careers"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 3683.01,
    transform: "translate(-640 -2183)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Testimonial 10",
    clipPath: "url(#clip0_200_1114)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 857.012,
    transform: "translate(-640 -272)",
    fill: "#F2F8FD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1410146910"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1410146906"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stars sec-",
    clipPath: "url(#clip1_200_1114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn bxs-star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.4522 14.9144C36.3501 14.6136 36.1621 14.3493 35.9114 14.154C35.6608 13.9588 35.3584 13.8413 35.0417 13.8159L25.7776 13.0798L21.7687 4.2057C21.641 3.91988 21.4334 3.67712 21.1708 3.50672C20.9082 3.33631 20.6019 3.24555 20.2889 3.24538C19.9758 3.24521 19.6694 3.33563 19.4067 3.50575C19.1439 3.67586 18.936 3.9184 18.808 4.20407L14.7991 13.0798L5.53497 13.8159C5.22371 13.8406 4.92614 13.9544 4.67787 14.1438C4.4296 14.3331 4.24113 14.59 4.13502 14.8836C4.02891 15.1773 4.00964 15.4953 4.07953 15.7996C4.14941 16.1039 4.30549 16.3816 4.52909 16.5996L11.3752 23.2734L8.95397 33.7579C8.88045 34.0753 8.90401 34.4074 9.0216 34.7112C9.13919 35.015 9.34537 35.2765 9.6134 35.4617C9.88142 35.6468 10.1989 35.7472 10.5247 35.7496C10.8504 35.7521 11.1694 35.6566 11.4402 35.4756L20.2883 29.5768L29.1365 35.4756C29.4133 35.6594 29.7397 35.754 30.0719 35.7467C30.404 35.7394 30.726 35.6306 30.9945 35.4348C31.263 35.2391 31.465 34.9658 31.5736 34.6518C31.6821 34.3378 31.6919 33.9981 31.6016 33.6783L28.6295 23.2783L36.0005 16.6451C36.4831 16.2096 36.6602 15.5303 36.4522 14.9144Z",
    fill: "#FFD600"
  }))))))), /*#__PURE__*/React.createElement("path", {
    d: "M-11754 -2615H6761V-2617H-11754V-2615ZM6762 -2614V5979H6764V-2614H6762ZM6761 5980H-11754V5982H6761V5980ZM-11755 5979V-2614H-11757V5979H-11755ZM-11754 5980C-11754.6 5980 -11755 5979.55 -11755 5979H-11757C-11757 5980.66 -11755.7 5982 -11754 5982V5980ZM6762 5979C6762 5979.55 6761.55 5980 6761 5980V5982C6762.66 5982 6764 5980.66 6764 5979H6762ZM6761 -2615C6761.55 -2615 6762 -2614.55 6762 -2614H6764C6764 -2615.66 6762.66 -2617 6761 -2617V-2615ZM-11754 -2617C-11755.7 -2617 -11757 -2615.66 -11757 -2614H-11755C-11755 -2614.55 -11754.6 -2615 -11754 -2615V-2617Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_200_1114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 857.012,
    fill: "white",
    transform: "translate(-640 -272)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_200_1114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 230.433,
    height: 39,
    fill: "white",
    transform: "translate(0.783691)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsIcon);
export default __webpack_public_path__ + "static/media/StarsIcon.c9d063d909cbeda009b1bd8ebf217df1.svg";
export { ForwardRef as ReactComponent };